import api from './api';

export const listPractices = () =>
  api.get('/api/v1/platform-admin/practices').then((r) => r.data.data.practices);

export const setFreeAccount = (practiceId, enabled) =>
  api.patch(`/api/v1/platform-admin/practices/${practiceId}/free-account`, { enabled }).then((r) => r.data);

export const extendTrial = (practiceId, days) =>
  api.patch(`/api/v1/platform-admin/practices/${practiceId}/extend-trial`, { days }).then((r) => r.data);
